import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import { ServerResponseSchema } from 'app'
import { Card, ProgressBar } from 'ui'

import MiniHeader from 'components/sports/soccer/matches/MiniHeader'
import Block from 'components/ui/Block'

import { biosecurityFetch } from '../../actions'
import { getStateBiosecurity } from '../../reducer'

import styles from './index.css'

const showBioBar = (percent, label = '') => {
  const value = Math.min(+percent || 0, 100)
  return (
    <div className={styles.bioBar}>
      {!!label && (
        <span>
          {label}: <b>{value}%</b>
        </span>
      )}
      <ProgressBar alert={value <= 90} value={value} />
    </div>
  )
}

class Biosecurity extends PureComponent {
  componentDidMount() {
    if (this.props.tournamentId && this.props.tournamentId !== this.props.biosecurity.data[0]?.tournament?.id) {
      this.props.biosecurityFetch(this.props.tournamentId)
    }
  }

  shouldRenderMatches = () => this.props.biosecurity.data[0]?.matches?.length > 0

  renderMatches() {
    const stages = {}

    for (const match of this.props.biosecurity.data[0].matches) {
      stages[match.stage.id] = {
        ...match.stage,
        rounds: {
          ...stages[match.stage.id]?.rounds,
          [match.round.id]: {
            ...match.round,
            matches: [...(stages[match.stage.id]?.rounds?.[match.round.id]?.matches || []), match],
          },
        },
      }
    }

    const { relevant_teams: relatedTeams } = this.props.biosecurity.data[0].tournament

    return (
      <div>
        <h3>Por encuentros</h3>
        {Object.values(stages)
          .sort((a, b) => (a.order > b.order ? 1 : -1))
          .map((stage) => (
            <div key={stage.id}>
              <h4>{stage.name}</h4>
              {Object.values(stage.rounds)
                .sort((a, b) => (a.order > b.order ? 1 : -1))
                .map((round) => (
                  <div key={round.id} className={styles.stage}>
                    <h5>{round.name}</h5>
                    <div className={styles.round}>
                      {round.matches

                        .sort((a, b) => (a.started_at || a.matched_at < b.started_at || b.matched_at ? 1 : -1))
                        .map((match) => (
                          <Card key={match.id} className={styles.card} elevation={1}>
                            <MiniHeader
                              bothLose={match.is_both_lose}
                              local={relatedTeams.find((t) => t.id === match.local_id)}
                              localDefinitionScore={match.local_definition_goals}
                              localScore={match.local_goals}
                              localWalkover={match.local_walkover}
                              size="big"
                              status="ok"
                              visitor={relatedTeams.find((t) => t.id === match.visitor_id)}
                              visitorDefinitionScore={match.visitor_definition_goals}
                              visitorScore={match.visitor_goals}
                              visitorWalkover={match.visitor_walkover}
                            />
                            {showBioBar(match.lineupsTotals.biosecure, 'Bioseguridad')}
                            {match.lineupsTotals.biosecure < 100 &&
                              showBioBar(match.lineupsTotals.local.biosecure, 'Local')}
                            {match.lineupsTotals.biosecure < 100 &&
                              showBioBar(match.lineupsTotals.visitor.biosecure, 'Visitante')}
                          </Card>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          ))}
      </div>
    )
  }

  renderTeams() {
    const teams = {}

    const { relevant_teams: relatedTeams } = this.props.biosecurity.data[0].tournament

    for (const match of this.props.biosecurity.data[0].matches) {
      teams[match.local_id] = {
        biosecure: (teams[match.local_id]?.biosecure || 0) + match.lineupsTotals.local.biosecure,
        filled: (teams[match.local_id]?.filled || 0) + match.lineupsTotals.local.filled,
        passed: (teams[match.local_id]?.passed || 0) + match.lineupsTotals.local.passed,
        team: teams[match.local_id]?.team || relatedTeams.find((t) => t.id === match.local_id),
        total: (teams[match.local_id]?.total || 0) + match.lineupsTotals.local.total,
        totalMatches: (teams[match.local_id]?.totalMatches || 0) + 1,
      }

      teams[match.visitor_id] = {
        biosecure: (teams[match.visitor_id]?.biosecure || 0) + match.lineupsTotals.visitor.biosecure,
        filled: (teams[match.visitor_id]?.filled || 0) + match.lineupsTotals.visitor.filled,
        passed: (teams[match.visitor_id]?.passed || 0) + match.lineupsTotals.visitor.passed,
        team: teams[match.visitor_id]?.team || relatedTeams.find((t) => t.id === match.visitor_id),
        total: (teams[match.visitor_id]?.total || 0) + match.lineupsTotals.visitor.total,
        totalMatches: (teams[match.visitor_id]?.totalMatches || 0) + 1,
      }
    }

    return (
      <div>
        <h3>Por equipos</h3>
        {Object.values(teams)

          .sort((a, b) =>
            Math.round(a.biosecure / a.totalMatches) < Math.round(b.biosecure / b.totalMatches) ? 1 : -1,
          )
          .map((team) => (
            <Card key={team.team.id} className={styles.card} elevation={1}>
              <h4>{team.team.name}</h4>
              {showBioBar(Math.round(team.biosecure / team.totalMatches), 'Bioseguridad')}
              <div className={styles.bioBar}>
                Encuentros <b>{team.totalMatches}</b>
                <br />
                Formularios <b>{team.total}</b>
              </div>
            </Card>
          ))}
      </div>
    )
  }

  render() {
    return (
      <div className="p-2 bg-white">
        {this.props.biosecurity.loading && <ProgressBar value={100} />}
        Número de encuentros: <b>{this.props.biosecurity.data[0]?.matches?.length || 0}</b>
        <br />
        Cumplimiento de bioseguridad: <b>{this.props.biosecurity.data[0]?.biosecure || 0} %</b>
        <br />
        {showBioBar(this.props.biosecurity.data[0]?.biosecure)}
        <Block className={styles.columns}>
          {this.shouldRenderMatches() && this.renderTeams()}
          {this.shouldRenderMatches() && this.renderMatches()}
        </Block>
      </div>
    )
  }
}

Biosecurity.propTypes = {
  biosecurity: ServerResponseSchema.isRequired,
  biosecurityFetch: PropTypes.func.isRequired,
  tournamentId: PropTypes.string.isRequired,
}

export default connect(
  (state) => ({
    biosecurity: getStateBiosecurity(state),
  }),
  {
    biosecurityFetch,
  },
)(Biosecurity)
